import { useTheme } from "@mui/material/styles";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

import { pluralize } from "core/strings";

import Box from "ui/atom/Box";
import Icon from "ui/atom/Icon";
import Content from "ui/Content";


export default function Info({ title, description, article, error, showCost }) {
	const theme = useTheme();
	const isCampaign = Boolean(article?.campaignBalance);
	const style = {
		info: { alignItems: "center", textAlign: "center" },
		token: { alignItems: "center" },
		error: { alignItems: "center", textAlign: "center" }
	};

	const label = isCampaign ? "Campaign" : "Subly";

	if (error) return (
		<Box.Column gap={1} sx={style.error}>
			<Icon name="circle-x" size={80} color={theme.palette.error.main} />
			<Box.Column gap={0.5}>
				<Typography variant="h2" color="error">Something didn’t work as expected.</Typography> {/* todo: get from api error code */}
				<Typography variant="h3" color="error">Please try again in a few moments.</Typography> {/* todo: get from api error code */}
			</Box.Column>
		</Box.Column>
	);

	return (
		<>
			<Box.Column gap={1.25} sx={style.info}>
				<Typography variant="h2">{!article ? <Skeleton variant="text" width={250} /> : title}</Typography>
				{description && <Typography variant="body1" color="text.secondary">{!article ? <Skeleton variant="text" width={350} /> : description}</Typography>}
				{showCost && (
					<Box.Column gap={1} sx={style.token}>
						<Icon name={isCampaign ? "campaign-coin" : "coin"} size={60} />
						<Typography variant="h4" color="text.coin">{!article ? <Skeleton variant="text" width={68} /> : `${pluralize(article?.pass?.tokens || article?.tokens, `${label} token`)}`}</Typography>
					</Box.Column>
				)}
			</Box.Column>
			<Content article={article} shadow />
		</>
	);
};